import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/csebald/bg_stetoskop_herz-removebg-preview.png";
import Profile from "../../images/csebald/c_sebald_2020.jpg";

const CSelabld = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Lebenslauf Dr. Claudia Sebald </h1>
                    <div>
                        <img src={Profile} style={{ float: "right", marginBottom: "30px" }} />
                        <div style={{ clear: "both" }}></div>
                    </div>

                       
                    <table>
                        <tr>
                            <td>Geburtsdatum und -ort</td>
                            <td>25.11.1968, Wien</td>
                        </tr>
                        <tr>
                            <td>Familienstand</td>
                            <td>verheiratet, zwei Kinder</td>
                        </tr>
                    </table>
                    <h3> Ausbildungsweg: </h3>
                    <table>
                        <tr>
                            <td>10.1996</td>
                            <td>Promotion zum Doktor der gesamten Heilkunde</td>
                        </tr>
                        <tr>
                            <td>1987-1996</td>
                            <td>Studium der Medizin an der Universität Wien</td>
                        </tr>
                        <tr>
                            <td>1975-1987</td>
                            <td>Volkschule und AHS im Sacre'-Coeur, 1030 Wien</td>
                        </tr>
                    </table>
                    <h3>Medizinische Praxis: </h3>
                    <table>
                        <tr>
                            <td>11.2013</td>
                            <td>Diplom für Tauchmedizin</td>
                        </tr>
                        <tr>
                            <td>ab 05.2011</td>
                            <td>Facharztordination für Innere Medizin und Kardiologie, 1150 Wien, alle Kassen</td>
                        </tr>
                        <tr>
                            <td>ab 05.2011</td>
                            <td>Umstellung von Wahlarztordination in Privatordination für Innere Medizin, 2350 Payerbach</td>
                        </tr>
                        <tr>
                            <td>04.2011 – 03.2009</td>
                            <td>Oberärztin am KH Neurologisches Zentrum Rosenhügel, Konsiliartätigkeit, Echokardiographie inkl. TEE für 1. und 2. Neurolog. Abtlg. und Pav. C, Diensttätigkeit auf neurologischer Intensivstation A2</td>
                        </tr>
                        <tr>
                            <td>10.2006 – 02.2009</td>
                            <td>
                            Additivfach Kardiologie, Hanusch KH:<br/>
                            - Kardiologische Praxis: Stationsarbeit inkl. Herzüberwachung<br/>
                            - Herzambulanz<br/>
                            - ICD und Schrittmacherambulanz<br/>
                            - Echokardiographie (TTE und TEE)
                            </td>
                        </tr>
                        <tr>
                            <td>04.2005 – 09.2006</td>
                            <td>Familienphase 2 (Geburt und Karenzzeit)</td>
                        </tr>
                        <tr>
                            <td>07.2004 – 03.2005</td>
                            <td>Gesundheitszentrum Nord, Herzambulanz</td>
                        </tr>
                        <tr>
                            <td>12.2002 – 03.2004</td>
                            <td>1. Med. Abt. für Gastroenterologie und Endokrinologie</td>
                        </tr>
                        <tr>
                            <td>08.2002 – 11.2002</td>
                            <td>3. Med. Abt. für Hämatologie</td>
                        </tr>
                        <tr>
                            <td>04.2002 – 07.2002</td>
                            <td>4. Med. Abt. für Geriatrie und Rheumatologie</td>
                        </tr>
                        <tr>
                            <td>11.2002</td>
                            <td>Facharztausbildung 2. Med. Abt. für Kardiologie</td>
                        </tr>
                        <tr>
                            <td>09.1998 – 01.2001</td>
                            <td>Sekundararzt in Ausbildung zum Facharzt für Innere Medizin, Hanuschkrankenhaus, 2. Med. Abt. für Kardiologie</td>
                        </tr>
                        <tr>
                            <td>03.1998 – 08.1998</td>
                            <td>Turnusarzt im Hanuschkrankenhaus, Interne Abteilung, 2. Med. für Kardiologie</td>
                        </tr>
                        <tr>
                            <td>03.1997 – 02.1998</td>
                            <td>Turnusarzt im Krankenhaus Baden – 10 Monate Chirurgie und Unfallchirurgie, 2 Monate Urologie</td>
                        </tr>
                        <tr>
                            <td>09.1995 – 11.1996</td>
                            <td>Wissenschaftliche Mitarbeit in der Notfallaufnahme AKH Wien</td>
                        </tr>
                        <tr>
                            <td>09.1991 – 02.1997</td>
                            <td>
                            Wissenschaftliche Mitarbeit am Ludwig Boltzmann-Institut für Arrhythmieforschung, 3. Med. Abt. WSP<br/>
                            - Schwerpunkttätigkeit: Elektrophysiologisches Labor, Katheterablation und ICD-Ambulanz<br/>
                            - Zusätzlich Studien und Vorträge
                            </td>
                        </tr>
                        <tr>
                            <td>07.1991 – 09.1991</td>
                            <td>Pflegedienst, AKH Wien, Internistische Intensivstation, II. Med. Abt.</td>
                        </tr>
                        </table>

                        <h3> Berufliche Weiterbildung: </h3>
                        <table>
                    <tbody>
                        <tr>
                            <td>11.2013</td>
                            <td>Diplom für Tauchmedizin</td>
                        </tr>
                        <tr>
                            <td>ab 05.2011</td>
                            <td>Facharztordination für Innere Medizin und Kardiologie 1150 Wien alle Kassen</td>
                        </tr>
                        <tr>
                            <td>ab 05.2011</td>
                            <td>Umstellung von Wahlarztordination in Privatordination für Innere Medizin, 2350 Payerbach</td>
                        </tr>
                        <tr>
                            <td>06.2010 - 04.2011</td>
                            <td>Wahlarztordination für Innere Medizin und Kardiologie, Ordinationszentrum Confraternität 1080 Wien</td>
                        </tr>
                        <tr>
                            <td>09.2007 bis 04.2011</td>
                            <td>Wahlarztordination für Innere Medizin, 2350 Payerbach</td>
                        </tr>
                        <tr>
                            <td>2005 - 2020</td>
                            <td>Ärztliche Sachverständige am Bundessozialamt Wien</td>
                        </tr>
                        <tr>
                            <td>2005 - 2009</td>
                            <td>Additivfach Kardiologie</td>
                        </tr>
                        <tr>
                            <td>04.2005</td>
                            <td>Herzechoprüfung</td>
                        </tr>
                        <tr>
                            <td>03.2005</td>
                            <td>Facharzt für Innere Medizin</td>
                        </tr>
                        <tr>
                            <td>09.2004</td>
                            <td>Facharztprüfung für Innere Medizin</td>
                        </tr>
                        <tr>
                            <td>2001</td>
                            <td>Notarztdekret</td>
                        </tr>
                        <tr>
                            <td>2000</td>
                            <td>Psychosomatisches Curriculum II</td>
                        </tr>
                    </tbody>
                    </table>


                </div>

            </section>
            <Footer />
        </main>
    )
}

export default CSelabld;
